import L from 'leaflet'
import 'leaflet-control-geocoder'

export default {
  data () {
    return {
      geocoder: new L.Control.Geocoder.Mapbox(process.env.VUE_APP_MAPBOX_ACCESS_TOKEN)
    }
  },
  methods: {
    geocode (input) {
      return new Promise((resolve, reject) => {
        this.geocoder.geocode(input, (data, err, res) => {
          if (err) reject(err)

          resolve(data)
        })
      })
    }
  }
}
